<template>
  <div>
    <div class="row">
      <div class="col-md-6"><canvas id="report_management"></canvas></div>
    </div>
  </div>
</template>
<script>
import ApiService from '@/core/services/api.service'
import Chart from 'chart.js/auto'
import ReportsManagement from './reports-management-report'

export default {
  name: 'ReportManagement',
  props: {
    bulan: String,
    tahun: Number,
    nilai_resiko: String,
  },
  data() {
    return {
      cReportsManagement: '',
      reportsManagement: ReportsManagement,
    }
  },
  created() {
    this.urlStorage = ApiService.urlStorage()
  },
  mounted() {
    const ctx = document.getElementById('report_management')
    this.cReportsManagement = new Chart(ctx, this.reportsManagement)
    this.loadChart()
  },
  methods: {
    async loadChart() {
      await ApiService.get(
        '/management_report/getChartData?bulan=' +
          this.bulan +
          '&tahun=' +
          this.tahun +
          '&nilai_kritis=' +
          this.nilai_resiko
      )
        .then(({ data }) => {
          this.cReportsManagement.data.labels = []
          this.cReportsManagement.data.datasets.forEach((dataset) => {
            dataset.data = []
          })

          if (data.data.length != 0) {
            for (const item of data.data) {
              this.cReportsManagement.data.labels.push(item.status)
              this.cReportsManagement.data.datasets.forEach((dataset) => {
                dataset.data.push(item.total)
              })
            }

            this.cReportsManagement.options.plugins.title.text = [
              'Grafik Management Report',
              'Periode ' + this.bulan + ' - ' + this.tahun,
              'Nilai Resiko = ' + this.nilai_resiko,
            ]
          } else {
            this.cReportsManagement.options.plugins.title.text = [
              'Grafik Management Report Tidak Ditemukan',
            ]
          }

          this.cReportsManagement.update()
        })
        .catch((response) => {
          console.log(response)
        })
    },
  },
  watch: {
    bulan: function () {
      this.loadChart()
    },
    tahun: function () {
      this.loadChart()
    },
  },
}
</script>
